module.exports = __webpack_public_path__ + "img/my-vaccine-pass.7d006735.png";